// extracted by mini-css-extract-plugin
export default {"prefix":"CurrencyInput--prefix--8c6854","fullBorder":"CurrencyInput--fullBorder--4175f1","suffix":"CurrencyInput--suffix--f1088d"};